import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Content Rating`}</h2>
    <p>{`GIFs are for everyone, and GIPHY is committed to making sure that its GIF search is a positive experience for everyone. We take content safety extremely seriously. Our GIF and Sticker library is thoroughly moderated and organized by rating in order to give GIPHY users the safest possible search experience. We do not hesitate to remove content that falls outside of our Community Guidelines.`}</p>
    <h3>{`GIPHY Content Rating Specifics:`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`G`}</strong>{`: Content that is appropriate for all ages and people.`}</li>
      <li parentName="ul"><strong parentName="li">{`PG`}</strong>{`: Content that is generally safe for everyone, but may require parental preview before children can watch.`}</li>
      <li parentName="ul"><strong parentName="li">{`PG-13`}</strong>{`: Mild sexual innuendos, mild substance use, mild profanity, or threatening images. May include images of semi-naked people, but DOES NOT show real human genitalia or nudity.`}</li>
      <li parentName="ul"><strong parentName="li">{`R`}</strong>{`: Strong language, strong sexual innuendo, violence, and illegal drug use; not suitable for teens or younger. NO NUDITY.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      